const type = 'SET_CARD_UNBLOCK_SUBMITTING';

const setCardUnblockSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCardUnblockSubmitting;
